var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBonus3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H192V192H16C7.16344 192 0 184.837 0 176V16Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.805 117.659L138 138M128.667 91.3333C128.667 111.952 111.952 128.667 91.3333 128.667C70.7147 128.667 54 111.952 54 91.3333C54 70.7147 70.7147 54 91.3333 54C111.952 54 128.667 70.7147 128.667 91.3333Z",
    stroke: "url(#paint0_linear_5809_7951)",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5809_7951)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 91.5,
    r: 34.5,
    fill: "#1EBEAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9212 96.2366C94.643 96.2366 96.4758 94.1987 96.4758 91.2853V82.1349C96.4758 79.2079 94.643 77.1836 91.9212 77.1836C89.1856 77.1836 87.3528 79.2079 87.3528 82.1349V91.2853C87.3528 94.1987 89.1856 96.2366 91.9212 96.2366ZM82.1279 91.5041C82.1279 96.8658 85.6705 100.627 90.8817 101.065V104.252H85.8072C85.2328 104.252 84.7677 104.717 84.7677 105.291C84.7677 105.866 85.2328 106.317 85.8072 106.317H98.0214C98.5959 106.317 99.0609 105.866 99.0609 105.291C99.0609 104.717 98.5959 104.252 98.0214 104.252H92.947V101.065C98.1719 100.627 101.701 96.8658 101.701 91.5041V88.7276C101.701 88.1531 101.249 87.7017 100.675 87.7017C100.1 87.7017 99.6354 88.1531 99.6354 88.7276V91.4221C99.6354 96.0862 96.5989 99.1773 91.9212 99.1773C87.2297 99.1773 84.1933 96.0862 84.1933 91.4221V88.7276C84.1933 88.1531 83.7419 87.7017 83.1538 87.7017C82.5793 87.7017 82.1279 88.1531 82.1279 88.7276V91.5041Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5809_7951",
    x1: 96,
    y1: 54,
    x2: 96,
    y2: 138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EEF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEDBE6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5809_7951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 69,
    fill: "white",
    transform: "translate(57 57)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonus3);
export default __webpack_public_path__ + "static/media/bonus3.c965bb60baa8cefb2386a8cf022f67f8.svg";
export { ForwardRef as ReactComponent };